"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPickerField = void 0;
const material_ui_color_1 = require("material-ui-color");
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const Popover_1 = __importDefault(require("@material-ui/core/Popover"));
const locale_context_1 = require("../../providers/locale/locale-context");
const color_picker_styles_1 = require("./color-picker-styles");
const colorToHexString = (color) => {
    return '#' + (color === null || color === void 0 ? void 0 : color.hex) || '00000000';
};
const createColorFromValue = (value) => {
    return (0, material_ui_color_1.createColor)(value || '#00000000');
};
function ColorPickerField({ value, onChange, disabled, }) {
    // localization from library default (English)
    const intl = (0, react_intl_1.useIntl)();
    const { locale } = (0, react_1.useContext)(locale_context_1.LocaleContext);
    const localMessages = {
        Set: intl.formatMessage({
            id: 'EAS_COLOR_PICKER_SET',
            defaultMessage: 'Nastavit',
        }),
        'Wrong format': intl.formatMessage({
            id: 'EAS_COLOR_PICKER_WRONG_FORMAT',
            defaultMessage: 'Nesprávný formát',
        }),
        'Not an hex value': intl.formatMessage({
            id: 'EAS_COLOR_PICKER_NOT_AN_HEX_VALUE',
            defaultMessage: 'Nejedná se o hexadecimální hodnotu',
        }),
    };
    (0, material_ui_color_1.useTranslate)(() => ({
        i18n: { language: locale.name },
        t: (v) => localMessages[v],
    }));
    const [open, setOpen] = (0, react_1.useState)(false);
    const refPicker = (0, react_1.useRef)(null);
    const handleChange = (newValue) => {
        setOpen(false);
        onChange(colorToHexString(newValue));
    };
    const classes = (0, color_picker_styles_1.useStyles)();
    return (react_1.default.createElement("div", { className: classes.root },
        disabled && (react_1.default.createElement("div", { style: { backgroundColor: value || '#00000000', width: '100%' } })),
        !disabled && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { ref: refPicker, style: {
                    '--picker-hover-color': value || '#00000000',
                    '--picker-hover-opacity': 0.8,
                }, onClick: () => setOpen(true) },
                react_1.default.createElement(material_ui_color_1.ColorButton, { color: createColorFromValue(value) })),
            open && (react_1.default.createElement(Popover_1.default, { id: "color-popover", open: open, anchorEl: refPicker.current, onClose: () => setOpen(false), anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center',
                } },
                react_1.default.createElement(material_ui_color_1.ColorBox, { value: createColorFromValue(value), onChange: handleChange, deferred: true })))))));
}
exports.ColorPickerField = ColorPickerField;
//# sourceMappingURL=color-picker.js.map